import React, { useContext } from "react";
import { ExpertiseContext } from "../../App";
import ExpertiseCard from "./ExpertiseCard";

function SecondComponent() {
  const expertise = useContext(ExpertiseContext);

  return (
    <div>
      <div className="w-full py-10 flex justify-center items-center">
        <div className="w-full gap-5 flex flex-wrap justify-center items-center">
          {expertise.map((skill) => (
            <ExpertiseCard key={skill.id} skill={skill}/>
          ))}
        </div>
      </div>
    </div>
  );
}

export default SecondComponent;
